import { Box } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { adjustContentVisibility, Section, SectionTitle, SectionParagraph as Subtitle } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';
import { PriceCard } from './components';

const Title = styled(SectionTitle)`
  white-space: pre;
`;

const CardPriceListWrapper = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1100px;
  margin-top: 30px;
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export interface Item {
  readonly title: string;
  readonly subtitle?: string;
  readonly price: string;
  readonly cta: { readonly ctaLabel: string; readonly ctaUrl: string };
}

export interface PricesProps extends DefaultSectionProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly cardsData: Item[];
}

export const Prices: React.FC<PricesProps> = ({ title, subtitle, cardsData, ...sectionProps }) => {
  return (
    <StyledSection {...sectionProps} pt={[40, 70]} pb={[30, 50]}>
      <Title tabIndex={0} data-edit-for="title">
        {parse(title)}
      </Title>
      {subtitle != null && (
        <Box mt={'10px'}>
          <Subtitle tabIndex={0} data-edit-for="subtitle">
            {parse(subtitle)}
          </Subtitle>
        </Box>
      )}
      <CardPriceListWrapper>
        {cardsData.map(item => (
          <PriceCard item={item} key={item.title} />
        ))}
      </CardPriceListWrapper>
    </StyledSection>
  );
};
